import type {Features} from '@/types/features.types';

export const myparcel_nederland: Features = {
  debug: {
    websockets: false,
  },
  events: {
    sknj: {
      endOfYear: false,
    },
  },
  errors: false,
  portal: {
    events: false,
  },
  page: {
    addresses: {
      import: true,
    },
    collectTrip: false,
    dashboard: true,
    prices: {
      scale: {
        dhl: true,
        dpd: true,
        postnl: true,
      },
    },
    settings: {
      shop: {
        emails: false,
        general: false,
        trackTrace: false,
      },
    },
    orders: {
      csvImport: false,
      mobile: false,
    },
    shipments: {
      overview: false,
      import: false,
      createReturn: false,
      createPallet: false,
    },
    users: false,
  },
  settings: {
    accountSettingsLegacy: false,
  },
  trackAndTraceModal: false,
} as const;
